// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_a20af9","root":"_0d23d8","ripple":"_b9a285","secondary":"_f48d51"};